import logger from 'helpers/logger';

interface EmbedHelperResult {
	isEmbedScript: boolean;
	formHtmlCode: string;
	sanitizedFormHtmlCode: string;
}

export const embedHelper = (htmlCode: string): EmbedHelperResult => {
	const formHtmlCode: string = htmlCode;
	const regExp = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
	const isEmbedScript = formHtmlCode && regExp.test(formHtmlCode);
	const sanitizedFormHtmlCode: string = isEmbedScript ? formHtmlCode.replace(regExp, '') : '';
	return { isEmbedScript, formHtmlCode, sanitizedFormHtmlCode };
};

export const canLoadScript = (scriptRef: React.RefObject<HTMLDivElement>, formHtmlCode: string): boolean => {
	if (!formHtmlCode) {
		logger.error('Form HTML code is empty or undefined.');
		return false;
	}
	if (scriptRef?.current?.childElementCount) {
		// Prevents double execution of the script if it already exists
		logger.info('Script already exists in the DOM, skipping script execution.');
		return false;
	}
	return true;
};
